import OnlyHeader from "components/Headers/OnlyHeader";
import ReactPaginate from "react-paginate";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
  Table,
} from "reactstrap";

const BackgroundChecks = () => {
  const totalPages = 5;
  const backgroundChecksData = [
    {
      id: 1,
      firstName: "Lena",
      lastName: "Baird",
      status: "completed",
    },
    {
      id: 4,
      firstName: "Lorena",
      lastName: "Buckley",
      status: "pending",
    },
    {
      id: 2,
      firstName: "Nicholas",
      lastName: "Hopkins",
      status: "in progress",
    },
    {
      id: 3,
      firstName: "Hester",
      lastName: "Mcdonald",
      status: "completed",
    },
    {
      id: 2,
      firstName: "Nicholas",
      lastName: "Holt",
      status: "pending",
    },
    {
      id: 3,
      firstName: "Sarah",
      lastName: "Mcbride",
      status: "in progress",
    },
    {
      id: 4,
      firstName: "June",
      lastName: "Moss",
      status: "completed",
    },
    {
      id: 5,
      firstName: "Leonard",
      lastName: "Bauer",
      status: "in progress",
    },
  ];

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="d-flex flex-column justify-content-between align-items-center flex-xl-row">
                  <Col className="">
                    <h3 className="text-center text-xl-left">
                      Background Check Requests
                    </h3>
                  </Col>
                  <Col className="d-flex flex-column flex-lg-row justify-content-around align-items-center">
                    <FormGroup className="mb-0 w-50">
                      <Input
                        id="userSearch"
                        name="Search"
                        placeholder="Search by ID / Name"
                        type="text"
                        // value={userSearchByName}
                        // onChange={(e) => setUserSearchByName(e.target.value)}
                        // bsSize="sm"
                        // className="py-3"
                      />
                    </FormGroup>
                    <div>
                      <Button
                        color="primary"
                        className="px-3 py-2 m-2"
                        // disabled={getUsersLoader}
                        // onClick={handleOnSubmit}
                        size="sm"
                      >
                        Search
                      </Button>
                      <Button
                        color="primary"
                        className="p-2 m-2"
                        // disabled={getUsersLoader}
                        // onClick={handleClearSearch}
                        size="sm"
                      >
                        Clear Search
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col">Status</th>
                    <th scope="col">actions</th>
                  </tr>
                </thead>
                <tbody>
                  {backgroundChecksData && backgroundChecksData.length > 0 ? (
                    backgroundChecksData?.map((user, index) => {
                      return (
                        <tr key={index}>
                          <td>{user?.firstName}</td>
                          <td>{user?.lastName}</td>
                          <td>{user?.status}</td>
                          <td>
                            <Button
                              size="sm"
                              color="primary"
                              // onClick={() => {
                              //   history.push(
                              //     `/admin/single-user-details/${user?.id}`
                              //   );
                              // }}
                            >
                              View Details
                            </Button>
                            <Button
                              size="sm"
                              color="primary"
                              style={{ width: "130px" }}
                              // onClick={() => {
                              //   setUserID(user?.id);
                              //   toggleModal();
                              // }}
                            >
                              Accept
                            </Button>
                            <Button
                              size="sm"
                              color="danger"
                              style={{ width: "130px" }}
                              // onClick={() => {
                              //   setUserID(user?.id);
                              //   toggleModal();
                              // }}
                            >
                              Reject
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        <p className="mb-0 text-sm">No Users Found.</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {totalPages > 0 && (
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      // onPageChange={handlePageChange}
                      containerClassName={
                        "pagination px-1 justify-content-end mb-0"
                      }
                      activeClassName={"active"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      nextClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextLinkClassName={"page-link"}
                    />
                  </nav>
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default BackgroundChecks;
